interface Props {
  fill?: string;
}
export default function Check(props: Props) {
  const { fill = "currentColor" } = props

  return(
    <svg width="1em" height="1em" viewBox="0 0 32 32"><path fill={fill} d="M16 22L6 12l1.4-1.4l8.6 8.6l8.6-8.6L26 12z"></path></svg>
  );
}